import React from "react";
import { Phone, Hammer, CalendarCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Phone,
    title: "Quick Discovery Call",
    desc: "We hop on a 15-minute call to learn your services, your audience, and how clients currently find you. No pitch — just listening.",
  },
  {
    n: "02",
    icon: Hammer,
    title: "We Build Your Funnel",
    desc: "We design and build a clean, mobile-first booking funnel around your services. You review, you approve, we ship.",
  },
  {
    n: "03",
    icon: CalendarCheck,
    title: "You Get Structured Bookings",
    desc: "We launch the site, integrate it with your booking tool, and you start getting confirmed appointments instead of DM threads.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="section bg-nav-950 relative overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute -top-32 -right-32 h-[420px] w-[420px] rounded-full bg-brand/15 blur-3xl"
      />
      <div className="container-x relative">
        <div className="max-w-3xl">
          <span className="eyebrow">
            <span className="h-1.5 w-1.5 rounded-full bg-brand" />
            How It Works
          </span>
          <h2 className="mt-4 h-display text-4xl sm:text-5xl">
            From <span className="text-brand">first chat</span> to first booked
            client — in days, not months.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-5 lg:gap-8 relative">
          <div
            aria-hidden="true"
            className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-nav-700 to-transparent"
          />

          {STEPS.map(({ n, icon: Icon, title, desc }, i) => (
            <div
              key={n}
              data-testid={`process-step-${i}`}
              className="relative rounded-2xl border border-nav-800 bg-nav-900/70 p-7 backdrop-blur-sm hover:border-brand/40 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-5xl font-bold text-nav-700">
                  {n}
                </span>
                <div className="grid place-items-center h-11 w-11 rounded-xl bg-brand text-white">
                  <Icon className="h-5 w-5" />
                </div>
              </div>
              <h3 className="mt-6 font-display font-bold text-2xl text-white">
                {title}
              </h3>
              <p className="mt-3 text-nav-400 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
